import axios, { AxiosInstance } from "axios";
import {
  resolveAssessmentServiceUrl,
  resolveAuthServiceUrl,
  resolveBaseUrl,
  resolveCourseServiceUrl,
  resolveNotificationServiceUrl,
  resolvePaymentServiceUrl,
  resolveSubdomainServiceUrl,
  resolveUserServiceUrl,
} from "configs/serviceUrls";

// Microservice URLs (dev: localhost; prod: https://<service>.compcheck.io unless REACT_APP_* overrides)
const AUTH_SERVICE_URL = resolveAuthServiceUrl();
const USER_SERVICE_URL = resolveUserServiceUrl();
export const COURSE_SERVICE_URL = resolveCourseServiceUrl();
const NOTIFICATION_SERVICE_URL = resolveNotificationServiceUrl();
const ASSESSMENT_SERVICE_URL = resolveAssessmentServiceUrl();
const PAYMENT_SERVICE_URL = resolvePaymentServiceUrl();
export const COMPCHECK_URL = (process.env.REACT_APP_COMPCHECK_URL || "https://server.compcheck.io").replace(/\/+$/, "");
const SUBDOMAIN_URL = resolveSubdomainServiceUrl();
const BASE_URL = resolveBaseUrl();

// Create base API instance
const createApiInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({ baseURL });

  instance.interceptors.request.use(
    async (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers = config.headers || {};
        if (config.headers && typeof config.headers === 'object' && !Array.isArray(config.headers)) {
          (config.headers as any).Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    (err) => Promise.reject(err)
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      // Skip auto-logout if request explicitly opts out
      const shouldSkipAutoLogout = (error.config as any)?.skipAutoLogout === true;
      
      // if (error.response?.status === 401 && !shouldSkipAutoLogout) {
      //   localStorage.removeItem("token");
      //   localStorage.removeItem("user");
      //   window.location.href = "/authentication/sign-in";
      // }
      return Promise.reject(error);
    }
  );

  return instance;
};

// Create service-specific API instances
export const authApi = createApiInstance(BASE_URL);
export const userApi = createApiInstance(USER_SERVICE_URL);
export const courseApi = createApiInstance(COURSE_SERVICE_URL);
export const notificationApi = createApiInstance(NOTIFICATION_SERVICE_URL);
export const assessmentApi = createApiInstance(ASSESSMENT_SERVICE_URL);
export const certificateApi = createApiInstance(COURSE_SERVICE_URL);
export const paymentApi = createApiInstance(PAYMENT_SERVICE_URL);
export const compcheckApi = createApiInstance(COMPCHECK_URL);
export const subdomainApi = createApiInstance(SUBDOMAIN_URL);
// Default export for backward compatibility
const api = authApi;
export default api;
